export const SPECIFIC_EMPLOYEE = 'specific_employee';
export const DIRECT_MANAGER = 'direct_manager';